import i18n from '@/i18n'
import Store from '@/store'
import ReportHeading from '@/Utils/report-head'
import pdfMake from 'pdfmake/build/pdfmake'
import pdfFontsBn from 'pdfmake/build/vfs_fonts_bn'
import pdfFontsEn from 'pdfmake/build/vfs_fonts_en'

const exportPdfDetails = async (baseUrl, uri = '/report-heading/detail', orgId, reportTitle, formData, vm) => {
    try {
        Store.commit('mutateCommonProperties', {
            loading: true
        })
        if (i18n.locale === 'bn') {
            pdfMake.vfs = pdfFontsBn.pdfMake.vfs
        } else {
            pdfMake.vfs = pdfFontsEn.pdfMake.vfs
        }
        const reportHeadData = await ReportHeading.getReportHead(baseUrl, uri, orgId)
        const pdfContent = []
        pdfContent.push(
            {
                table: {
                    style: 'tableData',
                    headerRows: 0,
                    widths: ['25%', '50%', '25%'],
                    body: [
                        [
                            { image: reportHeadData.reportHeadColumn[0].image, height: 50, width: 50, alignment: 'center', rowSpan: 5 },
                            { text: vm.$t('production_store.govt_info'), style: 'govt_info', alignment: 'center' },
                            { image: reportHeadData.reportHeadColumn[1].image, height: 50, width: 50, alignment: 'center', rowSpan: 5 }
                        ],
                        [
                            {},
                            { text: reportHeadData.orgName, style: 'header2', alignment: 'center' },
                            {}
                        ],
                        [
                            {},
                            { text: reportHeadData.heading, style: 'address', alignment: 'center' },
                            {}
                        ],
                        [
                            {},
                            { text: reportHeadData.address, style: 'address', alignment: 'center' },
                            {}
                        ],
                        [
                            {},
                            {},
                            {}
                        ]
                    ]
                },
                layout: {
                    hLineWidth: function (i, node) {
                        return 0
                    },
                    vLineWidth: function (i, node) {
                        return 0
                    }
                }
            }
        )
        pdfContent.push(
            { text: reportTitle, style: 'header', alignment: 'center' }
        )
        // exam type title
        const examTypeTitle = []

        const q1 = (vm.$i18n.locale === 'en' ? (formData.exam_type === 1 ? 'Pre-Evaluation' : 'Post-Evaluation') : formData.exam_type === 1 ? 'প্রাক-মূল্যায়ন' : 'সমাপনী')
        examTypeTitle.push(
            [
                { text: q1 + ' - ' + vm.getBatchName(formData.batch_id), style: 'td', alignment: 'center', bold: true }
            ]
        )
        pdfContent.push({
            table: {
                headerRows: 1,
                widths: ['100%'],
                body: examTypeTitle
            },
            layout: {
                hLineWidth: function (i, node) {
                    return 0
                },
                vLineWidth: function (i, node) {
                    return 0
                }
            }
        })
        // exam type title
        const tf = vm.$i18n.locale === 'en' ? 'T/F' : 'স/মি'
        const examInfo = []

        examInfo.push(
            [
                { stack: [[vm.$t('tp_management.training') + ' ' + vm.$t('globalTrans.name') + ': ' + vm.getTrainingName(formData.training_name_id)]], style: 'th', alignment: 'left', bold: false },
                { stack: [[vm.$t('trainer_trainee.batch') + ': ' + vm.getBatchName(formData.batch_id)]], style: 'th', alignment: 'right', bold: false }
            ],
          [
            { stack: [[vm.$t('globalTrans.fiscal_year') + ': ' + vm.getFiscalYear(formData.fiscal_year_id)]], style: 'th', alignment: 'left', bold: false },
            { stack: [[vm.$t('tp_management.circular_no') + ': ' + vm.getCircularName(formData.circular_id)]], style: 'th', alignment: 'right', bold: false }
          ],
            [
                { text: (vm.$i18n.locale === 'en' ? 'Time: ' : 'সময়: ') + vm.EngBangNum(vm.tConvert(formData.start_time)) + ' - ' + vm.EngBangNum(vm.tConvert(formData.end_time)), style: 'th', alignment: 'left', bold: false },
                { text: (vm.$i18n.locale === 'en' ? 'Total Marks- ' : 'পূর্ণমান- ') + vm.$n(formData.total_marks, { useGrouping: false }), style: 'th', alignment: 'right' }
            ]
        )
        pdfContent.push({
            table: {
                headerRows: 1,
                widths: ['50%', '50%'],
                body: examInfo
            },
            layout: {
                hLineWidth: function (i, node) {
                    return 0
                },
                vLineWidth: function (i, node) {
                    return 0
                }
            }
        })
        pdfContent.push({ text: vm.$i18n.locale === 'en' ? '1. If true, give tick mark on T, if false, give tick mark on F.' : '১. সত্য হলে স মিথ্যা হলে মি এর উপর টিক চিহ্ন দিন।', style: 'td', alignment: 'left', fontSize: '12' })
        if (formData.details.length > 0) {
            const msqLength = formData.details.filter(item => item.q_type === 2).length + 1
            formData.details.filter(item => item.q_type === 1).map((value, index) => {
                const newList = []
                newList.push([
                    { text: vm.$n(index + 1) + ') ' + value.question + ' ' + tf, style: 'td', alignment: 'left', marginLeft: 20 },
                    { text: vm.$n(value.marks), style: 'td', alignment: 'right', marginRight: 4 }
                ])

                pdfContent.push({
                    table: {
                        headerRows: 1,
                        widths: ['80%', '20%'],
                        body: newList
                    },
                    layout: {
                        hLineWidth: function (i, node) {
                            return 0
                        },
                        vLineWidth: function (i, node) {
                            return 0
                        }
                    }
                })
            })
            // type 2
            pdfContent.push({ text: '', marginTop: 10 })
            formData.details.filter(item => item.q_type === 2).map((value, index) => {
                const newList = []
                newList.push([
                    { text: vm.$n(index + 2) + '. ' + value.question, style: 'td', alignment: 'left', fontSize: '12' },
                    { text: value.marks, style: 'td', alignment: 'right', marginRight: 4 }
                ])
                pdfContent.push({
                    table: {
                        headerRows: 1,
                        widths: ['80%', '20%'],
                        body: newList
                    },
                    layout: {
                        hLineWidth: function (i, node) {
                            return 0
                        },
                        vLineWidth: function (i, node) {
                            return 0
                        }
                    }
                })
                value.multiple_option.map((newval, indx) => {
                    pdfContent.push({ text: (indx + 1) + ') ' + newval.option, style: 'td', alignment: 'left', marginLeft: 20 })
                })
                pdfContent.push({ text: '', marginTop: 5 })
            })
            //    type 3
            formData.details.filter(item => item.q_type === 3).map((value, index) => {
                const newList = []
                newList.push([
                    { text: (index + 1 + msqLength) + '. ' + value.question, style: 'td', alignment: 'left', fontSize: '12' },
                    { text: vm.$n(value.marks), style: 'td', alignment: 'right', marginRight: 4 }
                ])
                pdfContent.push({
                    table: {
                        headerRows: 1,
                        widths: ['80%', '20%'],
                        body: newList
                    },
                    layout: {
                        hLineWidth: function (i, node) {
                            return 0
                        },
                        vLineWidth: function (i, node) {
                            return 0
                        }
                    }
                })
                pdfContent.push({ text: 'Ans. ', style: 'td', alignment: 'left', marginLeft: 20 })
                pdfContent.push({ text: '', marginBottom: 35 })
            })
        }
        const waterMarkText = i18n.locale === 'bn' ? 'সমাজ কল্যাণ মন্ত্রণালয়' : 'Ministry of Social welfare'
        var docDefinition = {
            content: pdfContent,
            pageSize: 'A4',
            pageOrientation: 'portrait',
            watermark: { text: waterMarkText, color: 'blue', opacity: 0.1, bold: true, italics: false },
            styles: {
                th: {
                    border: 0,
                    fontSize: 10,
                    margin: [3, 3, 3, 3]
                },
                th1: {
                    border: 0,
                    fontSize: 10,
                    margin: [3, 3, 3, 3]
                },
                td: {
                    border: 1,
                    fontSize: 8,
                    margin: [3, 3, 3, 3]
                },
                td2: {
                    border: 0,
                    fontSize: 10,
                    alignment: 'center'
                },
                header: {
                    border: 0,
                    margin: [0, 1, 0, 15],
                    fontSize: 14,
                    alignment: 'center'
                },
                left_header: {
                    margin: [4, 0, 0, 10]
                },
                oderDetails: {
                    border: true,
                    fontSize: 14
                },
                govt_info: {
                    margin: [0, 1, 0, 1],
                    fontSize: 15,
                    alignment: 'center'
                },
                address: {
                    border: 0,
                    fontSize: 10,
                    bold: true,
                    margin: [0, 0, 0, 5]
                },
                address2: {
                    border: 0,
                    fontSize: 12,
                    bold: true,
                    margin: [0, 0, 0, 5]
                },
                left_logo: {
                    border: 0,
                    margin: [5, 0, 0, 5]
                }
            }
        }
        pdfMake.createPdf(docDefinition, null, null, null).print()
    } catch (error) {
        if (error) {
        }
    }
    Store.commit('mutateCommonProperties', {
        loading: false
    })
}
export default {
    exportPdfDetails
}
